import { Validator } from 'react-admin';
import { TextInput, TextInputProps } from 'shared/react-admin/Inputs';

import { IP_PLACEHOLDER, IP_REGEX } from './constants/constants';

export type IpAddressInputProps = TextInputProps;

const validateIpAddress: Validator = (value: string) =>
  !value || IP_REGEX.test(value) ? undefined : 'Введите корректный IP-адрес';

const parseIpAddress = (value: string): string =>
  value
    .replace(/[^\d.]/g, '')
    .replace(/\.+/g, '.')
    .replace(/^\./, '')
    .split('.')
    .slice(0, 4)
    .map((octet) => octet.slice(0, 3))
    .join('.');

export const IpAddressInput: React.FC<IpAddressInputProps> = ({ validate, ...restProps }) => {
  const validators = Array.isArray(validate) ? validate : validate ? [validate] : [];

  return (
    <TextInput
      parse={parseIpAddress}
      placeholder={IP_PLACEHOLDER}
      validate={[...validators, validateIpAddress]}
      {...restProps}
    />
  );
};
